/*----------------------------------------------------------------------------
|
| Library to load OSS Data Dictionary in various UIs
|
| Usage:
|
|   DataDict.all --> loads all data from the data dictionary
|
|   DataDict.min --> loads min. data from the data dictionary (area-wise)
|
|   DataDict.custom --> loads custom data from the data dictionary (area-wise)
|
|   DD --> function to retrieve area-wise label/desc for the given field name
|
|
| written by Alok Upendra Kamat
|
| October 2020
|
\----------------------------------------------------------------------------*/

DataDict = {
  data: [],
  all: function(cb, errcb) {
    GET("/os/ossui/v1/in/dataDictionary/json/en", '', function(data) {
      this.data = data;
      if (cb) cb(data);
    }.bind(this), function(statusText, errObj, respText) {
      if (errcb) {
        errcb(statusText, errObj, respText);
      }
    });
  },
  min: function(area, cb, errcb) {
    var requestObj = {
      area: area,
      properties: [area + '_field', 'name', 'short_desc', 'db_field']
    }
    POST("/os/ossui/v1/in/dataDictionary/min", requestObj, function(data) {
      this.data = data;
      if (cb) cb(data);
    }.bind(this), function(statusText, errObj, respText) {
      if (errcb) {
        errcb(statusText, errObj, respText);
      }
    });
  },
  custom: function(area, properties, cb, errcb) {
    var requestObj = {
      area: area,
      properties: properties
    }
    POST("/os/ossui/v1/in/dataDictionary/min", requestObj, function(data) {
      this.data = data;
      if (cb) cb(data);
    }.bind(this), function(statusText, errObj, respText) {
      if (errcb) {
        errcb(statusText, errObj, respText);
      }
    });
  },
  get: function(field, area='osv', align) {
    var areaField = area + '_field';

    if (align == undefined) {
      align = "";
    }
    
    if (area == 'ext_widget') {
      var val = { dd_label: field, dd_area: area, dd_align: align, dd_name: "", dd_desc: "" , dd_nrep: "" , dd_orep: ""};
      for (var i = 0; i < DataDict.data.length; i++) {
        if(DataDict.data[i]['name'] == field || DataDict.data[i]['db_field'] == field) {
          val.dd_label = DataDict.data[i][areaField] == "" ? field : DataDict.data[i][areaField];
          val.dd_name  = DataDict.data[i]['name'];
          val.dd_desc  = DataDict.data[i]['short_desc'];
          val.dd_nrep  = DataDict.data[i]['new_ext_rep_field'];
          val.dd_orep  = DataDict.data[i]['old_ext_rep_field'];
          break;
        }
      }
    } else {
      var val = { dd_label: field, dd_area: area, dd_align: align, dd_name: "", dd_desc: "" , dd_irep: "" , dd_bmt: ""};
      for (var i = 0; i < DataDict.data.length; i++) {
        if(DataDict.data[i]['name'] == field || DataDict.data[i]['db_field'] == field) {
          val.dd_label = DataDict.data[i][areaField] == "" ? field : DataDict.data[i][areaField];
          val.dd_name  = DataDict.data[i]['name'];
          val.dd_desc  = DataDict.data[i]['short_desc'];
          val.dd_irep  = DataDict.data[i]['int_rep_field'];
          val.dd_bmt   = DataDict.data[i]['bmt_field'];
          break;
        }
      }
    }
    return val;
  }
}

if (typeof(exports) !== "undefined") {
  exports.DataDict = DataDict;
  exports.DD = DataDict.get;
}
